import cx from 'classnames'
import {ReactNode, useEffect} from 'react'

type Props = {
  children: ReactNode
  className?: string
}

export const Modal = ({children, className}: Props) => {
  useEffect(() => {
    document.body.style.overflowX = 'hidden'
    document.body.style.overflowY = 'hidden'

    return () => {
      document.body.style.overflowX = 'auto'
      document.body.style.overflowY = 'auto'
    }
  })

  return (
    <div className="fixed w-screen h-dvh top-0 left-0 bg-black bg-opacity-50 flex justify-center items-end d:items-center z-[10000]">
      <div className={cx('bg-white w-full d:w-[390px] rounded-t-lg d:rounded-b-lg', className)}>{children}</div>
    </div>
  )
}
